import { c as _c } from "react/compiler-runtime";
import styles from '@/styles/components/EditorialContentCard.module.scss';
import { generateImageUrl } from '@/lib/sanity/image';
import { isWrittenContent } from '@/types/content';
import Image from 'next/image';
import Link from 'next/link';
import { generateLocalizedURL } from '@/utils/url';
const DEFAULT_LAYOUT = {
  orientation: 'vertical',
  aspectRatio: '3/2',
  size: 'medium',
  showImage: true,
  showLead: false,
  showAuthor: false,
  showPublishedAt: false,
  showTag: true,
  showReadingTime: false
};
const resolveImageResolution = (aspectRatio, size) => {
  const resolutions = {
    '3/2': {
      small: {
        width: 300,
        height: 200
      },
      medium: {
        width: 600,
        height: 400
      },
      large: {
        width: 1200,
        height: 800
      }
    },
    '1/1': {
      small: {
        width: 100,
        height: 100
      },
      medium: {
        width: 200,
        height: 200
      },
      large: {
        width: 600,
        height: 600
      }
    },
    '16/9': {
      small: {
        width: 320,
        height: 180
      },
      medium: {
        width: 480,
        height: 270
      },
      large: {
        width: 960,
        height: 540
      }
    },
    '4/3': {
      small: {
        width: 400,
        height: 300
      },
      medium: {
        width: 800,
        height: 600
      },
      large: {
        width: 1600,
        height: 1200
      }
    },
    auto: {
      small: {
        width: 300,
        height: 300
      },
      medium: {
        width: 600,
        height: 600
      },
      large: {
        width: 1200,
        height: 1200
      }
    }
  };
  return resolutions[aspectRatio || '3/2'][size || 'medium'];
};
const EditorialContentCard = t0 => {
  const $ = _c(49);
  const {
    variant,
    content,
    layout: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const layout = t2;
  let renderAuthor;
  let renderTag;
  let showAuthor;
  let showLead;
  let showTag;
  let t3;
  let t4;
  let t5;
  if ($[2] !== content || $[3] !== layout || $[4] !== variant) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const {
        orientation: t6,
        direction: t7,
        aspectRatio: t8,
        size: t9,
        showImage: t10,
        showLead: t11,
        showAuthor: t12,
        showTag: t13,
        customClassNames
      } = {
        ...DEFAULT_LAYOUT,
        ...layout
      };
      showLead = t11;
      showAuthor = t12;
      showTag = t13;
      const orientation = t6 === undefined ? "vertical" : t6;
      const direction = t7 === undefined ? "normal" : t7;
      const aspectRatio = t8 === undefined ? "3/2" : t8;
      const size = t9 === undefined ? "medium" : t9;
      const showImage = t10 === undefined ? true : t10;
      if (!isWrittenContent(content)) {
        console.warn("EditorialContentCard expects content of type WrittenContent.");
        t5 = null;
        break bb0;
      }
      const renderImage = () => {
        const resolution = resolveImageResolution(aspectRatio, size);
        const imageUrl = content.image ? generateImageUrl(content.image, resolution.width, resolution.height) : null;
        const aspectClass = aspectRatio !== "auto" ? `aspect-${aspectRatio.replace("/", "-")}` : "";
        return imageUrl ? <figure className={`${styles.mediaContainer} ${styles[aspectClass]}`}><Image src={imageUrl} alt={content.headline || "Content image"} className={styles.image} fill={true} /></figure> : <div className={`${styles.mediaContainer} ${styles[aspectClass]}`} />;
      };
      let t14;
      if ($[13] !== content.tags) {
        t14 = () => content.tags?.length && <strong className={styles.tag} style={{
          color: content.tags[0].color
        }}>{content.tags[0].title}</strong>;
        $[13] = content.tags;
        $[14] = t14;
      } else {
        t14 = $[14];
      }
      renderTag = t14;
      let t15;
      if ($[15] !== content.authors) {
        t15 = () => content.authors?.length && <div className={styles.authors}><div className={styles.author}><p className={styles.authorName}>{content.authors[0].name}</p></div></div>;
        $[15] = content.authors;
        $[16] = t15;
      } else {
        t15 = $[16];
      }
      renderAuthor = t15;
      let t16;
      if ($[17] !== content.authors) {
        t16 = () => {
          if (!content.authors?.length) {
            return null;
          }
          const authorImage = generateImageUrl(content.authors[0].image, 96, 96);
          return authorImage ? <figure className={`${styles.mediaContainer} ${styles.aspectSquare}`}><Image src={authorImage} alt={content.authors[0].name || "Author image"} className={styles.authorImage} fill={true} /></figure> : <div className={`${styles.mediaContainer} ${styles.aspectSquare}`} />;
        };
        $[17] = content.authors;
        $[18] = t16;
      } else {
        t16 = $[18];
      }
      const renderAuthorImage = t16;
      t3 = `${styles.card} ${styles[`card--${variant}`]} ${styles[orientation]} ${styles[direction]} ${customClassNames}`;
      t4 = showImage && (variant === "opinion" ? renderAuthorImage() : renderImage());
    }
    $[2] = content;
    $[3] = layout;
    $[4] = variant;
    $[5] = renderAuthor;
    $[6] = renderTag;
    $[7] = showAuthor;
    $[8] = showLead;
    $[9] = showTag;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    renderAuthor = $[5];
    renderTag = $[6];
    showAuthor = $[7];
    showLead = $[8];
    showTag = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  let t6;
  if ($[19] !== renderTag || $[20] !== showTag) {
    t6 = showTag && renderTag();
    $[19] = renderTag;
    $[20] = showTag;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== content.language || $[23] !== content.shorthandUrl || $[24] !== content.slug) {
    t7 = content.shorthandUrl ? content.shorthandUrl : generateLocalizedURL(content.slug, content.language, false);
    $[22] = content.language;
    $[23] = content.shorthandUrl;
    $[24] = content.slug;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  const t8 = content.shorthandUrl ? "_blank" : undefined;
  let t9;
  if ($[26] !== content.headline) {
    t9 = <h3 className={styles.headline}>{content.headline}</h3>;
    $[26] = content.headline;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t7 || $[29] !== t8 || $[30] !== t9) {
    t10 = <Link href={t7} className={styles.link} target={t8} prefetch={false}>{t9}</Link>;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== t10 || $[33] !== t6) {
    t11 = <header>{t6}{t10}</header>;
    $[32] = t10;
    $[33] = t6;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== content.lead || $[36] !== showLead) {
    t12 = showLead && content.lead && <p className={styles.lead}>{content.lead}</p>;
    $[35] = content.lead;
    $[36] = showLead;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== renderAuthor || $[39] !== showAuthor) {
    t13 = showAuthor && renderAuthor();
    $[38] = renderAuthor;
    $[39] = showAuthor;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  let t14;
  if ($[41] !== t11 || $[42] !== t12 || $[43] !== t13) {
    t14 = <main className={styles.content}>{t11}{t12}{t13}</main>;
    $[41] = t11;
    $[42] = t12;
    $[43] = t13;
    $[44] = t14;
  } else {
    t14 = $[44];
  }
  let t15;
  if ($[45] !== t14 || $[46] !== t3 || $[47] !== t4) {
    t15 = <article className={t3}>{t4}{t14}</article>;
    $[45] = t14;
    $[46] = t3;
    $[47] = t4;
    $[48] = t15;
  } else {
    t15 = $[48];
  }
  return t15;
};
export default EditorialContentCard;